"use strict";

exports.__esModule = true;
var _ElementEditorContext = require("./ElementEditorContext");
Object.keys(_ElementEditorContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorContext[key]) return;
  exports[key] = _ElementEditorContext[key];
});